import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Title', prop: 'title' },
  { title: 'URL', prop: 'slug' },
  { title: 'Published', prop: 'published_at', format: 'fromNow' },
  { title: 'Last Modified', prop: 'updated_at', format: 'fromNow' },
  { title: 'Members Only', prop: 'requires_membership', format: 'bool' }
]

const filters = [
  { name: 'Filter by title', prop: 'filters.title_ilike', type: 'text', enabled: true },
  { name: 'Filter by slug', prop: 'filters.slug_ilike', type: 'text', enabled: true }
]

const defaults = {
  order: [{ column: 'title', direction: 'asc' }]
}

const CmsPages = (props) => (
  <List
    title='Pages'
    apiPath='admin/cms_pages'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default CmsPages
